import type { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

// This file has styling for using Kuiper `<Menu>` in combination with Lapidary
// `<Popover>`--controlled by the `disableKuiperStyling` prop.

export const container = ({ height }: { height: number }): CSSObject => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minBlockSize: height,
  padding: Spacing.XS,

  '& > div': {
    flex: '1 1 1px',
  },
})

export const option: CSSObject = {}
